<template lang="pug">
  .columns
    .column.is-12.has-text-centered
      table#tbItemsTickets.table.is-striped.is-responsive
        thead
          tr
            th Equipo
            th Tipo
            th Solicita
            th Atendido
            th Problema
            th Prioridad
        tbody
          tr(v-for="(i, index) in items")
            td 
              .field
                input.is-checkradio(type='checkbox' v-model="itemsArraySel" :value="i" :id="i.id")
                label(:for="i.id") {{ i.equipo}}
            td
              span.tag.is-danger(v-if="i.tipo === 't'")
                | Ticket
              span.tag.is-black(v-else)
                | Solicitud
            td {{ i.solicita }}
            td {{ i.resuelve }}
            td {{ i.problema }}
            td(v-html="getPrioridad(i.restante)")
</template>

<script>
  import InventarioServices from '../../services/inventario/inventario'
  export default {
    name: 'ListItems',
    props: {
      tickets_solicitudes: {
        type: Array,
        default: () => []
      },
      tickets_solicitudesSel: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        items: [],
        itemsArraySel: []
      }
    },
    watch: {
      itemsArraySel() {
        this.$emit('countItems', this.itemsArraySel)
      },
      tickets_solicitudes () {
        this.items.length = 0
        this.items = this.tickets_solicitudes
      },
      tickets_solicitudesSel () {
        this.checkItemsSelected()
      }
    },
    methods: {
      iniciarComponente() {

      },
      
      getPrioridad (restante) {
        switch (true) {
          case restante == 0:
            return '<span class="tag is-danger">Alta</span>'
          case restante <= 7:
            return '<span class="tag is-warning">Normal</span>'
          case restante >= 8 :
            return '<span class="tag is-light">Baja</span>'
        }
      },
      checkItemsSelected() {
        if (this.tickets_solicitudes.length > 0 && this.tickets_solicitudesSel.length > 0) {
          this.tickets_solicitudesSel.map( ticketSel => {
            let exist = {}
            if (exist = this.tickets_solicitudes.find( tick => tick.id === ticketSel.id)) {
              this.itemsArraySel.push(exist)
            }
          })
        }
      }
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/requisiciones_Componentes/ListItems.vue